import { useCallback, useMemo, useState } from "react";

export default function useDropZoneHelper() {
  const [files, setFiles] = useState([]);
  const [rejections, setRejections] = useState([]);

  const resetDropZone = useCallback(() => {
    setFiles([]);
    setRejections([]);
  }, []);

  const dropZoneHelper = useMemo(() => ({
    setFiles,
    setRejections,
    files,
    rejections,
  }), [files, rejections]);

  return {
    files,
    resetDropZone,
    dropZoneHelper,
  }
}